import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  createHttpLink,
} from "@noom/hive-core";
import { createAuthLink } from "@noom/hive-auth";

import { getPrDeployRoutingHeaders } from "./prDeployRouting";

const httpLink = createHttpLink({
  uri: process.env.HIVE_GRAPHQL_URL as string,
});

const prDeployRoutingLink = new ApolloLink((operation, forward) => {
  const routingHeaders = getPrDeployRoutingHeaders();

  if (Object.keys(routingHeaders).length > 0) {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...routingHeaders,
        ...headers,
      },
    }));
  }

  return forward(operation);
});

// Auth handling (Authorization header + 401 refresh+retry) lives in a hive-auth
// Apollo link that reads from the AuthStore on every request, so React state and
// the outgoing header cannot drift.
const authLink = createAuthLink({ ApolloLink });

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // `clientDateTime` is a per-request freshness signal that the
          // backend uses to compute time-relative fields (refill dates,
          // "today" comparisons, etc). It is NOT an identity field for
          // the response: two queries with the same identity args but
          // microseconds-apart `clientDateTime` values produce the same
          // logical result.
          //
          // We exclude `clientDateTime` from the cache key (rather than
          // allowlisting `accessCode`) so any future query argument is
          // automatically treated as identity by default — there's no
          // risk of accidentally collapsing two distinct responses if
          // the schema gains a new variable later.
          treatmentOverviews: {
            keyArgs: (args) => {
              if (!args) return false;
              const { clientDateTime: _ignored, ...identityArgs } = args;
              return JSON.stringify(identityArgs);
            },
          },
        },
      },
    },
  }),
  link: authLink.concat(prDeployRoutingLink).concat(httpLink),
});
